module.exports = __webpack_public_path__ + "img/login-top-bg.ccfe73d0.svg";